import React from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";
import './app.scss';

import Home from "./containers/Home";
import FirstYear from './containers/FirstYear';
import SecondYear from "./containers/SecondYear";
import ThirdYear from "./containers/ThirdYear";
import FourthYear from "./containers/FourthYear";
import FifthYear from './containers/FifthYear';
import SixthYear from "./containers/SixthYear";

function App() {
    return (
        <div className="App">
            <Router>
                <Switch>
                    <Route path="/cuaderno-de-vacaciones/6-primaria" component={SixthYear} />
                    <Route path="/cuaderno-de-vacaciones/5-primaria" component={FifthYear} />
                    <Route path="/cuaderno-de-vacaciones/4-primaria" component={FourthYear} />
                    <Route path="/cuaderno-de-vacaciones/3-primaria" component={ThirdYear} />
                    <Route path="/cuaderno-de-vacaciones/2-primaria" component={SecondYear} />
                    <Route path="/cuaderno-de-vacaciones/1-primaria" component={FirstYear} />
                    <Route path="/cuaderno-de-vacaciones" component={Home} />
                    {/*<Route path="/6-primaria" component={SixthYear} />*/}
                    {/*<Route path="/5-primaria" component={FifthYear} />*/}
                    {/*<Route path="/4-primaria" component={FourthYear} />*/}
                    {/*<Route path="/3-primaria" component={ThirdYear} />*/}
                    {/*<Route path="/2-primaria" component={SecondYear} />*/}
                    {/*<Route path="/1-primaria" component={FirstYear} />*/}
                    {/*<Route path="/" component={Home} />*/}
                </Switch>
            </Router>
        </div>
    );
}

export default App;
